
    
    <div class="main-title">
        <div class="headings">
            <h1>The Region’s Leading Event For Content Creators</h1>
            <p>Celebrating the region’s top talents</p>
        </div>
    </div>
<div class="video-area">
            <div class="page-start-video-container d-flex align-items-center">
            <video style="width: 100%;" (click)="playPause()" id="my_video_1">
                <source src="https://jskxtziozwllyjpxoyne.supabase.co/storage/v1/object/public/brandripplr/web/home/cca.mp4#t=1.8" type="video/mp4" />
            </video>
            <button *ngIf="!isPlaying" (click)="playPause()"><img src="assets/images/play.svg"></button>
        </div>


</div>
<div class="container">
    <p>Brand Ripplr hosts the MENA Content Creator Awards every year to recognise and award the region’s talents and bring together leading brands across different industries and top content creators across MENA.</p>
    
    <p>
        <a href="https://menacreatorsawards.com" class="btn-find" target="_blank">Find out more</a>
    </p>
</div>